import { motion } from "framer-motion";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

const chapters = [
  {
    n: "01",
    title: "Growth runs on partnerships",
    body: "Real estate doesn't grow in isolation. Every project moves forward through relationships between builders and the channel partners who bring buyers.",
  },
  {
    n: "02",
    title: "The right opportunities are hard to find",
    body: "Discovering the right projects, the right partners, and the right moment to collaborate is still slow, manual, and mostly based on who you happen to know.",
  },
  {
    n: "03",
    title: "Collaboration is fragmented",
    body: "Deals live across calls, chats, and spreadsheets. Managing partnerships across disconnected channels makes trust and visibility difficult to build.",
  },
  {
    n: "04",
    title: "LintelGrid is a better way forward",
    body: "One network to discover opportunities, build reliable partnerships, and grow together — with the transparency the industry has been missing.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      className="relative bg-white py-16 sm:py-20"
      data-testid="manifesto-section"
    >
      <div className="mx-auto max-w-6xl px-2.5 sm:px-6">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="max-w-3xl"
        >
          <p className="eyebrow text-[#3b82f6]">The Problem / The Path</p>
          <h2 className="mt-4 text-3xl font-extrabold leading-[1.05] tracking-tight text-[#111827] sm:text-4xl">
            Real estate growth runs on strong partnerships.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-[#475569] sm:text-[17px]">
            But discovering the right opportunities, building reliable
            partnerships, and managing collaboration across fragmented channels
            remains difficult. We're building a better way forward.
          </p>
        </motion.div>

        <motion.div
          variants={stagger(0.05, 0.14)}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-[24px] border border-[#e5e7eb] bg-[#e5e7eb] sm:grid-cols-2"
        >
          {chapters.map((c) => (
            <motion.div
              key={c.n}
              variants={fadeUp}
              className="group relative bg-white p-7 transition-colors duration-500 hover:bg-[#f5f7fb]"
            >
              <span className="font-mono-plex text-sm font-medium text-[#3b82f6]">
                {c.n}
              </span>
              <h3 className="mt-3 text-lg font-bold tracking-tight text-[#111827]">
                {c.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-[#64748b]">
                {c.body}
              </p>
              <span className="mt-4 block h-px w-10 bg-[#1e3a8a] transition-all duration-500 group-hover:w-20" />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
